export const CONNECT_SUBSCRIBER_PREFIX = 'connect';
export function buildConnectSubscriberId(userId) {
    return `${CONNECT_SUBSCRIBER_PREFIX}:${userId}`;
}
export function buildAgentConnectionIdentifier(userId, agentId) {
    return `${CONNECT_SUBSCRIBER_PREFIX}:${userId}:agent:${agentId}`;
}
//# sourceMappingURL=connect-subscriber-id.js.map